import React from 'react';

import { Link } from 'react-router-dom';

import TenantConfig from '../../config';
import ErrorPage from '../../pages/ErrorPage';
import rudderanalytics from '../../service/rudderstack';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    console.warn(error.message, error.stack);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    //we send the error to newrelic
    if (typeof newrelic !== 'undefined') {
      newrelic.noticeError(error);
    }
    if (rudderanalytics) {
      rudderanalytics.track('error', {
        message: error?.message,
      });
    }
    console.warn('Something went wrong!', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage
          title="That was not expected..."
          message={
            'We are sorry about this!<br /> Please call our dedicated Call Center at' +
            '\n' +
            TenantConfig.general.callCenterPhoneNumber +
            ' for additional support.<br />' +
            '\n' +
            "We're available " +
            (TenantConfig.general?.callCenterHours
              ? TenantConfig.general?.callCenterHours
              : '6am - 5pm PT Monday to Friday')
          }
          linkButton={
            <Link
              to="/dashboard"
              onClick={() =>
                this.setState({
                  hasError: false,
                })
              }
            >
              Dashboard
            </Link>
          }
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
